import moment from 'moment';
import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Popover, Caret } from '../../../../../common/components';
import { useOutsideClick } from '../../../../../common/hooks';

function HorizontalBreak() {
  return <span>&nbsp;|&nbsp;</span>;
}

function PopoverButton({ buttonText, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [debounce, setDebounce] = useState(false);

  function handleClose() {
    if (!debounce && isOpen) {
      setIsOpen(false);
      setDebounce(true);
      setTimeout(() => setDebounce(false), 500);
    }
  }
  function handleOpen() {
    if (!debounce && !isOpen) {
      setIsOpen(true);
      setDebounce(true);
      setTimeout(() => setDebounce(false), 500);
    }
  }

  const ref = useRef(null);
  useOutsideClick(ref, handleClose);

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-light"
        onClick={handleOpen}
      >
        <span style={{ color: 'blue' }} className="text-decoration-underline">
          {buttonText}
        </span>
        <Caret className="ms-1" style={{ color: 'blue' }} isOpen={isOpen} />
      </button>
      <Popover
        isOpen={isOpen}
        containerRef={ref}
        style={{ width: '325px' }}
      >
        {children}
      </Popover>
    </>
  );
}

function DetailsPopover() {
  const {
    zip,
    premium,
    effectiveDate,
    planYear,
    quoteID,
    planName,
  } = useSelector(store => store.quote);
  return (
    <PopoverButton buttonText="Details">
      <b className="me-1">Zip code:</b> {zip}
      <br />
      <b className="me-1">Monthly premium:</b> ${premium}
      <br />
      <b className="me-1">Effective date:</b> {moment(effectiveDate).format('MM/DD/YYYY')}
      <br />
      <b className="me-1">Plan year:</b> {planYear}
      <br />
      <b className="me-1">Quote ID:</b> {quoteID}
      <br />
      <b className="me-1">Plan Name:</b> {planName}
      <br />
    </PopoverButton>
  );
}

function HoursPopover() {
  const { CustomerServiceHours } = useSelector(store => store.plan.plan);
  return (
    <PopoverButton buttonText="Hours">
      {CustomerServiceHours}
    </PopoverButton>
  );
}

function InfoBar() {
  const { firstName, lastName } = useSelector(store => store.shopper);
  const {
    planType,
    planName,
    carrier,
    plan: {
      MemberPhoneNumber,
    },
  } = useSelector(store => store.plan);

  return (
    <>
      <div className="col-md-2 p-2 ps-4 infobar-border">
        <h6 className="text-muted">Applicant</h6>
        <h5
          className="fw-bold mb-0"
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
          title={`${firstName} ${lastName}`}
        >
          {firstName} {lastName}
        </h5>
      </div>
      <div className="col-md-5 p-2 ps-4 infobar-border">
        <div
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          <span className="fw-bold" style={{ color: 'var(--bs-primaryFocus)' }}>{planType}</span>
          <HorizontalBreak />
          <span className="fw-bold">{carrier}</span>
          <HorizontalBreak />
          <i title={planName}>{planName}</i>
        </div>

        <DetailsPopover />
      </div>
      <div className="col-md-5 p-2 ps-4 infobar-border text-muted">
        Customer Service:
        <br />
        {MemberPhoneNumber || '[DR.MemberPhoneNumber]'}
        <HorizontalBreak />
        TTY: 777
        <HorizontalBreak />
        <HoursPopover />
      </div>
    </>
  );
}

export default InfoBar;
